
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
:host .calendar-container {
  padding: 24px;
  border-radius: 16px;
  position: relative;
  overflow: visible;
  display: block;
  justify-content: center;
  align-items: center;
  border: unset;
  outline: none;
  box-sizing: border-box;
  text-decoration: none;
  user-select: none;
  text-transform: none;
  font-family: var(--slh-default-font-family, "Open Sans");
  background-color: var(--slh-color-neutral-shade-00, #FFFFFF);
}
:host .calendar-container .date-holder {
  display: flex;
  margin-bottom: 24px;
}
:host .calendar-container .date-holder .prev-month,
:host .calendar-container .date-holder .next-month {
  cursor: pointer;
}
:host .calendar-container .date-holder .prev-month .icon-wrapper,
:host .calendar-container .date-holder .next-month .icon-wrapper {
  fill: var(--slh-color-neutral, #39455D);
}
:host .calendar-container .date-holder .prev-month:hover .icon-wrapper,
:host .calendar-container .date-holder .next-month:hover .icon-wrapper {
  fill: var(--slh-color-neutral-shade-60, #62779F);
}
:host .calendar-container .date-holder .date {
  flex-grow: 1;
  text-align: center;
  color: var(--slh-color-neutral-shade-80, #4E5E7E);
  font-size: var(--slh-base-m-font-size, 16px);
  font-weight: var(--slh-base-bold-font-weight, 700);
}
:host .calendar-container #calendar {
  width: 100%;
  margin: 0 auto;
  position: relative;
}
:host .calendar-container #calendar table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}
:host .calendar-container #calendar table .week-days {
  color: var(--slh-color-neutral-shade-60, #62779F);
  font-size: var(--slh-base-xxs-font-size, 12px);
  font-weight: var(--slh-base-semi-bold-font-weight, 600);
  text-align: center;
  text-transform: uppercase;
}
:host .calendar-container #calendar table .week-days td {
  padding-bottom: 16px;
}
:host .calendar-container #calendar table .week .day {
  width: 14.28%;
  text-align: center;
  font-size: var(--slh-base-xs-font-size, 14px);
  font-weight: var(--slh-base-semi-bold-font-weight, 600);
  line-height: var(--slh-base-xxs-line-height, 24px);
}
:host .calendar-container #calendar table .week .day:not(.other-month) {
  color: var(--slh-color-neutral-shade-80, #4E5E7E);
  cursor: pointer;
}
:host .calendar-container #calendar table .week .day span {
  min-width: 18px;
  padding: 6px 9px;
  display: inline-block;
  border-radius: var(--slh-base-s-line-height, 32px);
  vertical-align: middle;
  position: relative;
}
:host .calendar-container #calendar table .week .day span .item-dot {
  display: none;
}
:host .calendar-container #calendar table .week .day:not(.other-month) span:hover, :host .calendar-container #calendar table .week .day:not(.other-month) span.today {
  background: var(--slh-color-neutral-shade-20, #EBEEF4);
}
:host .calendar-container #calendar table .week .day:not(.other-month) span.active .item-dot {
  display: block;
  position: absolute;
  width: 4px;
  bottom: 4px;
  height: 4px;
  border-radius: 2px;
  left: calc(50% - 2px);
  background-color: var(--slh-color-primary, #3B87D4);
}
:host .calendar-container #calendar table .week .day.active:hover .popup {
  opacity: 1;
  display: block;
}
:host .calendar-container #calendar table .week .day.active:hover .popup-arrow-down {
  opacity: 1;
  display: block;
  position: absolute;
  top: -15px;
}
:host .calendar-container #calendar table .week .day .popup-arrow-down {
  z-index: 9;
  opacity: 0;
  width: 0;
  height: 0;
  display: none;
  border-style: solid;
  border-width: 15px 10px 0 10px;
  border-color: var(--slh-color-neutral-shade-00, #FFFFFF) transparent transparent transparent;
  filter: drop-shadow(0px 8px 24px var(--slh-color-neutral-shade-80-opacity-12, rgba(78, 94, 126, 0.16)));
  -webkit-filter: drop-shadow(0px 8px 24px var(--slh-color-neutral-shade-80-opacity-12, rgba(78, 94, 126, 0.16)));
}
:host .calendar-container #calendar table .week .day .popup {
  width: calc(100% + 24px);
  box-sizing: border-box;
  z-index: 2;
  left: -12px;
  position: absolute;
  margin-top: -165px;
  transition: all 0.25s ease;
  opacity: 0;
  display: none;
  background: none !important;
  padding: 0;
  padding-bottom: 20px;
  border-radius: 0px;
}
:host .calendar-container #calendar table .week .day .popup .popup-content-holder {
  filter: drop-shadow(0px 8px 24px var(--slh-color-neutral-shade-80-opacity-12, rgba(78, 94, 126, 0.16)));
  -webkit-filter: drop-shadow(0px 8px 24px var(--slh-color-neutral-shade-80-opacity-12, rgba(78, 94, 126, 0.16)));
  position: relative;
  overflow: visible;
  background-color: var(--slh-color-neutral-shade-00, #FFFFFF) !important;
  padding: 16px 16px 16px 24px;
  border-radius: 16px;
}
:host .calendar-container #calendar table .week .day .popup .popup-content-holder .popup-content {
  overflow-y: auto;
  text-align: left;
  height: 120px;
  padding: 0;
  margin: 0;
  /* Track */
  /* Handle */
}
:host .calendar-container #calendar table .week .day .popup .popup-content-holder .popup-content .popup-content-item:not(:last-child) {
  border-bottom: 1px solid var(--slh-color-neutral-shade-20, #EBEEF4);
  padding-bottom: 16px;
}
:host .calendar-container #calendar table .week .day .popup .popup-content-holder .popup-content::-webkit-scrollbar {
  width: 10px;
}
:host .calendar-container #calendar table .week .day .popup .popup-content-holder .popup-content::-webkit-scrollbar-track {
  background: var(--slh-color-neutral-shade-10, #F6F7FA);
}
:host .calendar-container #calendar table .week .day .popup .popup-content-holder .popup-content::-webkit-scrollbar-thumb {
  background: var(--slh-color-neutral-shade-20, #EBEEF4);
  border-radius: 10px;
}
:host .calendar-container #calendar table .week .day .popup .popup-content-holder .popup-content::-webkit-scrollbar-thumb:hover {
  background: var(--slh-color-neutral-shade-40, #C0C8D8);
}
:host .calendar-container #calendar table .other-month {
  color: var(--slh-color-neutral-shade-40, #C0C8D8);
}
`;
